import React from 'react'
import { Row, Col, Form, Collapse, Input } from 'antd';
import DisplayText from '../_DisplayText'
import { SelectBox, InputBox, isBrowser } from '../../../../shared/custom-ant-d'

const { Panel } = Collapse;

export const HKG = (props) => {
  const { months, onMonthChanged, daysOfMonth } = props;

  return (
    <>
      <Collapse defaultActiveKey={['1', '2']} expandIconPosition={'right'}>
        <Panel id='employ-verify' header="Employment Verification" key="1">
          <Row>
            <Col span={24}>
              <DisplayText
                text={`
                As part of the employment verification process, please provide the following information:
                `}
              />
            </Col>
          </Row><br />
          <Row justify="space-between">
            <Col md={{ span: 11 }} xs={24}>
              <Form.Item
                label={<b>{DisplayText(
                  {
                    mode: 'label',
                    text: props.getDisplayText('Employment Verification','Month Question'),
                  }
                )}</b>}
                name="monthOfBirth"
                initialValue={''}
                rules={[
                  {
                    required: true,
                    message: 'Please provide your Month of birth is required',
                  }
                ]}
              >
                <SelectBox
                  data={
                    months && (
                      months.map((item, i) => {
                        return (
                          { value: item, label: item }
                        );
                      })
                    )
                  }
                  label={''}
                  onChange={(value) => {
                    props.resetFieldValues({ monthOfBirth: value })
                    onMonthChanged(value)
                  }}
                  onDismiss={(value) => {
                    props.resetFieldValues({ monthOfBirth: value })
                  }} />
              </Form.Item>
            </Col>
            <Col md={{ span: 11 }} xs={ 24} >
              <Form.Item
                label={<b>{DisplayText(
                  {
                    mode: 'label',
                    text: props.getDisplayText('Employment Verification','Day Question'),
                  }
                )}</b>}
                name="dayOfBirth"
                rules={[
                  {
                    required: true,
                    message: 'Day of birth is required',
                  }
                ]}
                initialValue={''}
              >
                <SelectBox
                  data={
                    daysOfMonth && (
                      daysOfMonth.map((item, i) => {
                        return (
                          { value: item, label: item }
                        );
                      })
                    )
                  }
                  label={''}
                  onChange={(value) => {
                    props.resetFieldValues({ dayOfBirth: value })
                  }}
                  onDismiss={(value) => {
                    props.resetFieldValues({ dayOfBirth: value })
                  }} />
              </Form.Item>
            </Col>
          </Row>
        </Panel>
        <Panel id='apply-statement' header="Applicant Statement" key="2">
          <Row>
            <Col span={24}>
              <DisplayText
                text={props.getDisplayText('Applicant Statement','HKG Applicant Statement')}
                mode='ellipsis'
              />
            </Col>
          </Row><br />
          <Row>
            <Col md={{ span: 11 }} xs={24}>
              <Form.Item
                label={<b>Do you agree with the above Applicant Statement?</b>}
                name="applicantStatementAgreeInd"
                rules={[
                  {
                    required: true,
                    message: 'This field is required.',
                  }
                ]}
                initialValue={''}
              >
                <SelectBox
                  data={
                    [
                      { value: 'true', label: 'I Agree' }
                    ]
                  }
                  label={''}
                  onChange={(value) => {
                    props.resetFieldValues({ applicantStatementAgreeInd: value })
                  }}
                  onDismiss={(value) => {
                    props.resetFieldValues({ applicantStatementAgreeInd: value })
                  }} />
              </Form.Item>
            </Col>
            <Col md={{ span: 11, offset: 1 }} xs={24}>
              <Form.Item
                label={<b>Please type your full name to sign this application:</b>}
                name="applicantSignature"
                rules={[
                  {
                    required: true,
                    message: 'This field is required',
                  }
                ]}
                initialValue={''}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox />)
                }
              </Form.Item>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </>
  )
}
